var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6173 24.6368C16.2143 24.6368 15.8213 24.5148 15.4893 24.2878L5.29432 17.3248C4.38232 16.7018 4.14732 15.4568 4.77032 14.5448C4.91032 14.3398 5.08832 14.1618 5.29432 14.0218L15.4893 7.05985C16.4013 6.43685 17.6463 6.67085 18.2693 7.58285C18.4953 7.91585 18.6173 8.30885 18.6173 8.71085V9.58585L13.1833 13.7648C13.0913 13.8348 13.0063 13.9128 12.9283 13.9978L12.8173 14.1308C12.1433 15.0058 12.3073 16.2608 13.1823 16.9348L18.6173 21.1148V22.6378C18.6173 23.7418 17.7213 24.6378 16.6173 24.6378V24.6368ZM26.4553 24.6368C26.0523 24.6368 25.6593 24.5148 25.3273 24.2878L15.1323 17.3248C14.2203 16.7018 13.9863 15.4568 14.6093 14.5448C14.7493 14.3398 14.9273 14.1618 15.1323 14.0218L25.3273 7.05985C26.2393 6.43685 27.4843 6.67085 28.1073 7.58285C28.3343 7.91585 28.4553 8.30885 28.4553 8.71085L28.4553 22.6368C28.4553 23.7408 27.5603 24.6368 26.4553 24.6368Z",
    fill: "url(#hinava_random_uuid_134495622526535323137356913372903367739)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_134495622526535323137356913372903367739",
    x1: 16.4386,
    y1: 24.6378,
    x2: 16.4386,
    y2: 6.71105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackward);
export default __webpack_public_path__ + "static/media/backward.3c612380d9ee0f54bb6d217d00e4f56d.svg";
export { ForwardRef as ReactComponent };